<template>
    <div id="preview">
        <div>
            <h3 class="mobile-title">Ön İzleme</h3>
        </div>
        <div class="prev-header">
            <div class="screen-types">
                <div id="computer" :class="device === 4 ? 'button active' : 'button'" @click="device = 4">
                    {{ $t("newWizartV2.computer") }}
                </div>
                <div id="Tablet" class="button" :class="device === 3 ? 'button active' : 'button'" @click="device = 3">
                    {{ $t("newWizartV2.tablet") }}
                </div>
                <div class="button" :class="device === 1 ? 'button active' : 'button'" @click="device = 1">IOS</div>
                <div class="button" :class="device === 2 ? 'button active' : 'button'" @click="device = 2">ANDROID</div>
            </div>
        </div>
        <div class="prew-container">
            <div class="macbook-container" v-if="device === 4">
                <div class="marvel-device macbook position-relative">
                    <div class="top-bar"></div>
                    <div class="camera"></div>
                    <div class="screen">
                        <img
                            v-if="!!settings.website && uploaded.includes(settings.website)"
                            :src="screenshots().desktop"
                            style="width: 100%; height: 100%"
                            :key="'desktop' + renderCount"
                        />
                    </div>
                    <div class="livePreviewAbsolute">
                        <DemoVisitor />
                    </div>
                </div>
            </div>
            <div class="tablet-container" v-if="device === 3">
                <div class="marvel-device ipad silver">
                    <div class="camera"></div>
                    <div class="screen">
                        <img
                            v-if="!!settings.website && uploaded.includes(settings.website)"
                            :src="screenshots().tablet"
                            style="width: 100%; height: 100%"
                            :key="'tablet' + renderCount"
                        />
                    </div>
                    <div class="home"></div>
                    <div class="livePreviewAbsolute">
                        <DemoVisitor />
                    </div>
                </div>
            </div>
            <div class="iphone-container" v-if="device === 1">
                <div class="marvel-device iphone-x position-relative">
                    <div class="notch">
                        <div class="camera"></div>
                        <div class="speaker"></div>
                    </div>
                    <div class="top-bar"></div>
                    <div class="sleep"></div>
                    <div class="bottom-bar"></div>
                    <div class="volume"></div>
                    <div class="overflow">
                        <div class="shadow shadow--tr"></div>
                        <div class="shadow shadow--tl"></div>
                        <div class="shadow shadow--br"></div>
                        <div class="shadow shadow--bl"></div>
                    </div>
                    <div class="inner-shadow"></div>
                    <div class="screen">
                        <img
                            v-if="!!settings.website && uploaded.includes(settings.website)"
                            :src="screenshots().mobile"
                            style="width: 100%; height: 100%"
                            :key="'ios' + '' + renderCount"
                        />
                        <div class="livePreviewAbsolute">
                            <DemoVisitor />
                        </div>
                    </div>
                </div>
            </div>
            <div class="android-container" v-if="device === 2">
                <div class="marvel-device note8 position-relative">
                    <div class="inner"></div>
                    <div class="overflow">
                        <div class="shadow"></div>
                    </div>
                    <div class="speaker"></div>
                    <div class="sensors"></div>
                    <div class="more-sensors"></div>
                    <div class="sleep"></div>
                    <div class="volume"></div>
                    <div class="camera"></div>
                    <div class="screen">
                        <img
                            v-if="!!settings.website && uploaded.includes(settings.website)"
                            :src="screenshots().mobile"
                            style="width: 100%; height: 100%"
                            :key="'android' + renderCount"
                        />
                        <div class="livePreviewAbsolute">
                            <DemoVisitor />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../utils/log2";
import { mapActions, mapGetters, mapState } from "vuex";
import { sendSocketMessage } from "../../utils/socketStream";
import "../../assets/css/device.min.css";
import _ from "lodash";
import DemoVisitor from "../DemoVisitor.vue";
import ChatThemeEditor from "../../views/Pages/Settings/components/theme/ChatThemeEditor.vue";

const log = log2("Preview");
export default {
    name: "Preview",
    components: {
        DemoVisitor,
        ChatThemeEditor,
    },
    data() {
        return {
            device: 1,
            renderCount: 1,
            uploaded: [],
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        screenshots() {
            const { website } = this.settings;
            if (website && website.length) {
                const hostname = new URL(website.startsWith("http") ? website : `http://${website}`).hostname;
                const prefix = hostname.trim().toLowerCase();
                const randomId = Math.ceil(Math.random() * 10000);
                return {
                    desktop: `https://static.supsis.live/website-screenshots/${prefix}/desktop.jpg?i=${randomId}`,
                    mobile: `https://static.supsis.live/website-screenshots/${prefix}/mobile.jpg?i=${randomId}`,
                    tablet: `https://static.supsis.live/website-screenshots/${prefix}/tablet.jpg?i=${randomId}`,
                };
            }
            return {
                desktop: undefined,
                mobile: undefined,
                tablet: undefined,
            };
        },
        applySettings(newSettings) {
            log("applySettings", newSettings);
            this.updateSettings(newSettings).then(() => {
                sendSocketMessage("user settings-updated", {
                    siteId: this.site._id,
                });
            });
        },
    },
    mounted() {
        this.timerId = setInterval(async () => {
            const { website } = this.settings;
            const { desktop } = this.screenshots();
            log("check before", { website, desktop });
            if (website && desktop) {
                if (this.uploaded.includes(website)) return;
                log(`checking ${website}`);
                const status = (await fetch(desktop).then((x) => x.text())) || "";
                log(`check result ${website}`, { status });
                if (status.indexOf("Error") === -1) {
                    this.uploaded.push(website);
                    this.renderCount += 1;
                }
            }
        }, 2000);
    },
    beforeDestroy() {
        if (this.timerId) clearInterval(this.timerId);
    },
    watch: {
        settings: {
            handler: function (newSettings) {},
            deep: true,
        },
    },
};
</script>
<style scoped>
.mobile-title {
    display: none;
}

#preview {
    padding-bottom: 60px;

    .prev-header {
        margin-bottom: 30px;

        .screen-types {
            display: flex;
            justify-content: space-evenly;

            .button {
                font-family: "Poppins";
                font-size: 26px;
                font-weight: bold;

                user-select: none;
                cursor: pointer;
                position: relative;
                color: #aaaaaa;

                &.active {
                    color: #000000;

                    &:before {
                        content: "";
                        position: absolute;
                        bottom: -11px;
                        width: 100%;
                        height: 3px;
                        background-color: #ec4b1d;
                        left: 0px;
                    }
                }
            }
        }
    }

    .prew-container {
        width: 95%;
        max-width: 100vw;
        margin: 0 auto;
        padding: 0px;

        .macbook-container {
            width: 100%;
            display: flex;

            .marvel-device {
                width: 80%;
                margin: 0 auto;

                .livePreviewAbsolute {
                    width: 320px;
                    position: absolute;
                    z-index: 3;
                    //height: 417px; bottom: 170px;
                    right: 59px;
                }
            }
        }

        .tablet-container {
            width: 90%;
            display: flex;

            .marvel-device {
                width: 60%;
                margin: 0 auto;
                height: 630px;

                .livePreviewAbsolute {
                    width: 320px;
                    position: absolute;
                    z-index: 3;
                    //height: 417px; bottom: 180px;
                    right: 40px;
                }
            }
        }

        .iphone-container {
            width: 100%;
            display: flex;

            .marvel-device {
                width: 24%;
                margin: 0 auto;
                height: 630px;

                .notch {
                    //left: 86px;
                }

                .livePreviewAbsolute {
                    width: 346px;
                    position: absolute;
                    z-index: 3;
                    height: 508px;
                    bottom: 92px;
                    right: -8px;
                }
            }
        }

        .android-container {
            width: 95%;
            display: flex;

            .marvel-device {
                width: 24%;
                margin: 0 auto;
                height: 630px;

                .livePreviewAbsolute {
                    width: 327px;
                    position: absolute;
                    z-index: 3;
                    height: 538px;
                    bottom: 92px;
                    right: 0px;
                }
            }
        }
    }
}

@media (max-width: 1024px) {
    .mobile-title {
        display: flex;
        justify-content: center;
        font-weight: bold;
        color: #f3886a;
        padding: 10px;
    }

    #computer {
        display: none;
    }

    #Tablet {
        display: none;
    }

    #preview {
        .prew-container {
            .macbook-container {
                display: none !important;
                overflow: hidden !important;

                .marvel-device .macbook position-relative {
                    display: none !important;
                    overflow: hidden !important;

                    .top-bar .camera .screen .livePreviewAbsolute {
                        display: none !important;
                        overflow: hidden !important;
                    }
                }
            }

            .tablet-container {
                display: none;
                overflow: hidden;

                .marvel-device .macbook position-relative {
                    display: none !important;
                    overflow: hidden !important;

                    .marvel-device .macbook position-relative {
                        display: none !important;
                        overflow: hidden !important;

                        .top-bar .camera .screen .livePreviewAbsolute {
                            display: none !important;
                            overflow: hidden !important;
                        }
                    }
                }
            }
        }

        .iphone-container {
            .marvel-device {
                width: 100%;
                margin: 0 auto;
                height: 630px;

                .livePreviewAbsolute {
                    width: 100%;
                    position: absolute;
                    z-index: 3;
                    height: 417px;
                    bottom: 180px;
                    right: 0px;
                }
            }
        }

        .android-container {
            .marvel-device {
                width: 100%;
                margin: 0 auto;
                height: 630px;

                .livePreviewAbsolute {
                    width: 100%;
                    position: absolute;
                    z-index: 3;
                    height: 417px;
                    bottom: 180px;
                    right: 0px;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    #preview {
        .prew-container {
            .macbook-container {
                display: none;
            }

            .tablet-container {
                display: none;
            }

            .iphone-container {
                .marvel-device {
                    width: 100%;
                    margin: 0 auto;
                    height: 630px;

                    .notch {
                        //left: 86px;
                    }

                    .livePreviewAbsolute {
                        width: 100%;
                        position: absolute;
                        z-index: 3;
                        height: 508px;
                        bottom: 92px;
                        right: 0px;
                    }
                }
            }

            .android-container {
                .marvel-device {
                    width: 100%;
                    margin: 0 auto;
                    height: 630px;

                    .livePreviewAbsolute {
                        width: 100%;
                        position: absolute;
                        z-index: 3;
                        height: 538px;
                        bottom: 92px;
                        right: 0px;
                    }
                }
            }
        }
    }
}

@media (max-width: 480px) {
    #preview {
        .prew-container {
            .macbook-container {
                display: none;
            }

            .tablet-container {
                display: none;
            }

            .iphone-container {
                .marvel-device {
                    width: 100%;
                    margin: 0 auto;
                    height: 630px;

                    .notch {
                        left: 60px;
                        z-index: 99999999;
                    }

                    .livePreviewAbsolute {
                        width: 100%;
                        position: absolute;
                        z-index: 3;
                        height: 508px;
                        bottom: 92px;
                        right: 0px;
                    }
                }
            }

            .android-container {
                .marvel-device {
                    width: 100%;
                    margin: 0 auto;
                    height: 630px;

                    .livePreviewAbsolute {
                        width: 100%;
                        position: absolute;
                        z-index: 3;
                        height: 538px;
                        bottom: 92px;
                        right: 0px;
                    }
                }
            }
        }
    }
}
</style>
